import * as React from "react"

const NavItem = ({ item, active, setActive }) => {
  return (
    <button onClick={() => setActive(item.id)} className={`vertical-item ${active === item.id ? 'vertical-item--active': ''}`}>
      <h3>{item.name}</h3>
    </button>
  )
}

export default NavItem
